var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvitations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.587,
    height: 38.473,
    viewBox: "0 0 40.587 38.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invitations",
    transform: "translate(-335 -326.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M-11149.573,2185.356l1.483-3.408,2.272-1.988,2.431-.726h3.282l3.44,1.073,1.451,2.02.884,1.988.127,1.168-7.733,5.113Z",
    transform: "translate(11497.144 -1836.948)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M374.422,446.01a1.167,1.167,0,0,1,1.166,1.165v24.662H335v-25.1l.365-.4.305-.289.5-.033h.342l.346.223,18.433,13.383,18.721-13.592Zm-.943,23.719v-20.7l-18.185,13.2-18.185-13.2v20.7Z",
    transform: "translate(0 -107.312)",
    fill: "#3d4977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M338.68,340.949l-1.154-1.765,20.08-13.133,19.764,12.922-1.154,1.765-18.61-12.168Z",
    transform: "translate(-2.26)",
    fill: "#3d4977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M-5,6.227-6.332,4.595,8.743-7.74l1.335,1.632Z",
    transform: "translate(341.719 357.849)",
    fill: "#3d4977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M7.894,7.076-6.654-5.891l1.4-1.574L9.3,5.5Z",
    transform: "translate(365.515 357.182)",
    fill: "#3d4977"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2792",
    "data-name": "Ellipse 2792",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(351.144 333.052)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M453.1,459.2a6.815,6.815,0,0,1,6.732,5.817l1.923-.44A8.361,8.361,0,0,0,453.1,457a8.549,8.549,0,0,0-8.85,7.572l2.118.44A6.815,6.815,0,0,1,453.1,459.2Z",
    transform: "translate(-97.648 -116.144)",
    fill: "#3d4977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2792-2",
    "data-name": "Ellipse 2792",
    d: "M-4.834-10A5.171,5.171,0,0,1,.331-4.834,5.171,5.171,0,0,1-4.834.331,5.171,5.171,0,0,1-10-4.834,5.171,5.171,0,0,1-4.834-10Zm0,8.223A3.061,3.061,0,0,0-1.777-4.834,3.061,3.061,0,0,0-4.834-7.892,3.061,3.061,0,0,0-7.892-4.834,3.061,3.061,0,0,0-4.834-1.777Z",
    transform: "translate(360.181 342.317)",
    fill: "#3d4977"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitations);
export default __webpack_public_path__ + "static/media/Invitations.24352a1b452c73d588238ae6f6d7be59.svg";
export { ForwardRef as ReactComponent };